import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "123",
  height: "20",
  viewBox: "0 0 123 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M31.5 14.5V4H40.5V5.5H42V10H40.5V11.5H34.5V14.5H31.5ZM34.5 10H39V5.5H34.5V10ZM48 5.5V4H51V5.5H48ZM45 14.5V13H48V8.5H46.5V7H51V13H54V14.5H45ZM55.5 14.5V13H57V11.5H58.5V10H57V8.5H55.5V7H58.5V8.5H60V10H61.5V8.5H63V7H66V8.5H64.5V10H63V11.5H64.5V13H66V14.5H63V13H61.5V11.5H60V13H58.5V14.5H55.5ZM69 14.5V13H67.5V8.5H69V7H76.5V8.5H78V11.5H70.5V13H76.5V14.5H69ZM70.5 10H75V8.5H70.5V10ZM81 14.5V13H84V5.5H82.5V4H87V13H90V14.5H81Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }